module.exports = __webpack_public_path__ + "static/media/samfunnsdialog_homescreen_logo.aab2cdb7.png";